<script setup>
import { ref } from 'vue'
import { useUserStore } from '~/store/user'
import xModal from '@/components/common/xModal.vue'
import CandyAmount from './candyAmount.vue'
import isMobile from 'is-mobile'

const props = defineProps({
  dropTotal: {
    type: Object,
    default: () => ({}),
  },
  isLogin: {
    type: Boolean,
    default: false,
  },
})
const user = useUserStore()

const isshowModal = ref(false)
const modalType = ref('')
function toggleModalVisibility(type) {
  modalType.value = type
  isshowModal.value = !isshowModal.value
}
</script>

<template>
  <div>
    <div class="w-full bg-pageGray py-4 max-md:px-4 max-md:py-6 max-md:border-box max-md:relative">
      <div class="w-[1200px] m-auto max-md:w-full">
        <div class="flex justify-between items-center">
          <div class="flex flex-col gap-10 text-sm w-[800px] max-md:gap-4 max-md:w-full">
            <div class="text-5xl font-bold max-md:text-2xl">
              {{ $t('空投挖矿') }}
            </div>
            <div>
              <div class="max-md:flex-1">
                <div class="text-sm font-medium text-textPrimary  max-md:text-xs max-md:font-medium">
                  {{ $t('参与用户总数') }}
                </div>
                <div class="text-lg font-bold text-textPrimary max-md:text-base max-md:font-medium">
                  {{ props.dropTotal.totalUserCount ? fix(props.dropTotal.totalUserCount) : '--' }}
                </div>
              </div>

              <!-- <div class="max-md:flex-1">
                <div class="text-sm font-medium text-textSecondary  max-md:text-xs max-md:font-medium">
                  {{ $t('总空投') }}
                </div>
                <div class="text-lg font-bold text-textPrimary  max-md:text-base max-md:font-medium">
                  {{ props.dropTotal.totalAirdropValue ? `$${fix(props.dropTotal.totalAirdropValue)}` : '--' }}
                </div>
              </div> -->
            </div>
            <template v-if="isLogin && user?.info?.channelId?.toLowerCase?.() === 'tantin'">
              <div class="hidden max-md:flex max-md:gap-1 max-md:items-center">
                <CandyAmount :candy-count="props.dropTotal.candyCount" :candy-count-can-use="props.dropTotal.candyCountCanUse" @click-help="toggleModalVisibility" />
              </div>
              <div class="hidden items-center gap-20 max-md:flex max-md:gap-1">
                <div class="max-md:flex-1">
                  <div class="text-sm font-medium text-textSecondary max-md:text-xs max-md:font-medium">
                    {{ $t('我的团队初级KYC人数') }}
                  </div>
                  <div class="text-lg font-bold text-textPrimary max-md:text-base max-md:font-medium">
                    {{ dropTotal.juniorUser > 0 ? fix(dropTotal.juniorUser) : dropTotal.juniorUser }}
                  </div>
                </div>
                <div class="max-md:flex-1">
                  <div class="text-sm font-medium text-textSecondary  max-md:text-xs max-md:font-medium max-md:flex max-md:gap-1 max-md:items-start">
                    {{ $t('我的团队空投KYC人数') }}
                    <svgo-airdrop-ic-help class="ms-1 w-4 h-4 cursor-pointer max-md:w-3 max-md:h-3 flex-shrink-0 mt-px" @click="() => toggleModalVisibility('kyc')" />
                  </div>
                  <div class="text-lg font-bold text-textPrimary  max-md:text-base max-md:font-medium">
                    {{ dropTotal.juniorUserEffective > 0 ? fix(dropTotal.juniorUserEffective) : dropTotal.juniorUserEffective }}
                  </div>
                </div>
              </div>
            </template>

            <div v-if="isLogin && user?.info?.channelId?.toLowerCase?.() === 'tantin'" class="grid items-start gap-5 grid-cols-4  max-md:hidden">
              <template v-if="isLogin && !isMobile() && user?.info?.channelId?.toLowerCase?.() === 'tantin'">
                <CandyAmount :candy-count="props.dropTotal.candyCount" :candy-count-can-use="props.dropTotal.candyCountCanUse" @click-help="toggleModalVisibility" />
              </template>
              <div class="max-md:flex-1">
                <div class="text-sm font-medium text-textSecondary max-md:text-xs max-md:font-medium">
                  {{ $t('我的团队初级KYC人数') }}
                </div>
                <div class="text-lg font-bold text-textPrimary max-md:text-base max-md:font-medium">
                  {{ dropTotal.juniorUser > 0 ? fix(dropTotal.juniorUser) : dropTotal.juniorUser }}
                </div>
              </div>
              <div class="max-md:flex-1">
                <div class="flex items-start text-sm font-medium text-textSecondary !min-w-[160px]  max-md:text-xs max-md:font-medium  max-md:flex max-md:gap-1 max-md:items-center">
                  {{ $t('我的团队空投KYC人数') }}
                  <svgo-airdrop-ic-help class="w-4 h-4 ms-1 cursor-pointer max-md:w-3 max-md:h-3 flex-shrink-0 mt-0.5" @click="() => toggleModalVisibility('kyc')" />
                </div>
                <div class="text-lg font-bold text-textPrimary  max-md:text-base max-md:font-medium">
                  {{ dropTotal.juniorUserEffective > 0 ? fix(dropTotal.juniorUserEffective) : dropTotal.juniorUserEffective }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2 max-md:absolute max-md:right-6 max-md:top-2 max-md:hidden">
            <img src="@/assets/images/airdrop/header.png" alt="" class="w-[275px] max-md:w-[106px]">
          </div>
        </div>
      </div>
    </div>
    <xModal
      v-model:show="isshowModal"
      :width="isMobile() ? '90%' : '400px'"
      :hide-cancel="true"
      :title="$t('说明')"
      :ok-text="$t('知道了')"
      :ok="toggleModalVisibility"
      :cancel="toggleModalVisibility"
      @close="toggleModalVisibility"
    >
      <div class="leading-[20px] text-textSecondary">
        <p>{{ modalType === 'kyc' ? $t('我的团队当前已完成空投KYC的人数') : $t('可用于兑换空投的糖果数') }}</p>
        <p>{{ $t('*数据于每日UTC 0点更新') }}</p>
      </div>
    </xModal>
  </div>
</template>
